module.exports = __webpack_public_path__ + "img/Foot 2.5ea4a5c2.png";